<template>
  <a-table
    size="small"
    :columns="columns"
    :data-source="shifts"
    :pagination="false"
    :row-key="record => record.id"
    :row-selection="rowSelection"
    :scroll="{ x: 760 }"
    data-testid="final-paycheck-shifts"
  >
    <span slot="scheduled" slot-scope="text, record">
      {{ formatDateTime(record.scheduled_start) }} – {{ formatDateTime(record.scheduled_end) }}
    </span>

    <span slot="status" slot-scope="text, record">
      <a-tag :color="getShiftStatus(record.status).color">
        {{ getShiftStatus(record.status).title }}
      </a-tag>
    </span>

    <div slot="readiness" slot-scope="text, record" class="final-paycheck-readiness">
      <a-tag :color="getReadinessStatus(record.ready_for_pay_status).color">
        {{ getReadinessStatus(record.ready_for_pay_status).title }}
      </a-tag>
      <span v-if="getReadinessReasons(record).length" class="final-paycheck-readiness__reasons">
        {{ getReadinessReasons(record).join(', ') }}
      </span>
    </div>

    <span slot="amount" slot-scope="text, record">
      {{ formatMoney(record.amount) }}
    </span>
  </a-table>
</template>

<script>
import { Table, Tag } from 'ant-design-vue'
import { createNamespacedHelpers } from 'vuex'
import util from '@/util'

const { mapGetters: shiftGetters } = createNamespacedHelpers('shifts')

const READY_FOR_PAY_STATUS = Object.freeze({
  '-1': 'blocked',
  0: 'not_ready',
  1: 'ready'
})

export default {
  name: 'FinalPaycheckShiftsTable',
  components: {
    'a-table': Table,
    'a-tag': Tag
  },
  props: {
    shifts: {
      type: Array,
      default: () => []
    },
    selectedShiftIds: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      columns: [
        {
          title: 'Shift',
          key: 'scheduled',
          width: 260,
          scopedSlots: { customRender: 'scheduled' }
        },
        {
          title: 'Status',
          key: 'status',
          width: 120,
          scopedSlots: { customRender: 'status' }
        },
        {
          title: 'Readiness',
          key: 'readiness',
          width: 260,
          scopedSlots: { customRender: 'readiness' }
        },
        {
          title: 'Amount',
          key: 'amount',
          width: 120,
          align: 'right',
          scopedSlots: { customRender: 'amount' }
        }
      ]
    }
  },
  computed: {
    ...shiftGetters(['getShiftStatus', 'getReadyForPaymentStatus', 'getNotReadyForPaymentFlag']),

    rowSelection() {
      return {
        selectedRowKeys: this.selectedShiftIds,
        onChange: selectedShiftIds => this.$emit('update:selectedShiftIds', selectedShiftIds)
      }
    }
  },
  methods: {
    formatDateTime(value) {
      return util.convertDateTimeToCurrentTimeZoneWithFormat(value, 'MM/DD/YYYY h:mm A') ?? '—'
    },

    formatMoney(value) {
      return value == null ? '—' : `$${util.convertDbToMoney(value).toFixed(2)}`
    },

    getReadinessStatus(value) {
      return this.getReadyForPaymentStatus(READY_FOR_PAY_STATUS[value] ?? value)
    },

    getReadinessReasons(shift) {
      return Object.entries(shift.reasons ?? {})
        .filter(([, active]) => active)
        .map(([reason]) => this.getNotReadyForPaymentFlag(reason).title)
    }
  }
}
</script>

<style scoped>
.final-paycheck-readiness {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}

.final-paycheck-readiness__reasons {
  color: var(--text-color-secondary);
  font-size: 12px;
}
</style>
